<script>
import { getVcode } from '@/api/user/update';
import { clearTimeout } from 'timers';

export default {
  props: {
    text: String,
    cellphone: String,
  },
  data() {
    return {
      defaultText: this.text ? this.text : '获取验证码',
      counting: false,
      count: 60,
      timer: null,
      showImgBox: false,
      vcode: null,
      inputCode: '',
    };
  },
  methods: {
    countStart() {
      this.counting = true;
      this.countDown();
    },
    countDown() {
      const count = this.count;
      if (count == 1) {
        this.counting = false;
        this.count = 60;
        this.timer = null;
      } else {
        const timer = setTimeout(() => {
          this.countDown();
        }, 1000);
        this.count = count - 1;
        this.timer = timer;
      }
    },
    clickHandle() {
      if (this.cellphone && this.cellphone.length == 11) {
        getVcode({
          params: {
            cellphone: this.cellphone,
          },
        })
          .then(res => {
            this.countStart();
            this.$message.success(res.msg || '发送成功');
            this.vcode = null;
            this.inputCode = '';
          })
          .catch(console.error);
      } else {
        this.$message.error('请输入正确的手机号');
      }
    },
  },
  render(h) {
    return (
      <div>
        {this.counting ? (
          <div class="Vcode Counting">{`${this.count}S后重发`}</div>
        ) : (
          <div class="Vcode" onClick={this.clickHandle}>
            {this.defaultText}
          </div>
        )}
      </div>
    );
  },
};
</script>

<style lang="scss">
.Vcode.Counting {
  color: #999;
}
</style>
